<script setup lang="ts">
import AppLayout from "@/layout/AppLayout.vue";
import { useQuasar } from "quasar";
const $q = useQuasar();

// set status
$q.dark.set(true);
</script>

<template>
  <app-layout />
</template>

<style scoped></style>
